import { AbstractControl, ValidationErrors } from "@angular/forms";

export function numberExistValidator(control: AbstractControl): ValidationErrors| null {

  if(control && (control.value !== null || control.value !== undefined)){
    const validate = /\d/.test(control.value);

    if (!validate){
      return {
        'numberExistValidator' : true
      };
    }
  }

  return null;
}
